module.exports = "/_next/static/images/2-682d0e2982fa572d44f53bb6c0c4b221.jpg";